module.exports = __webpack_public_path__ + "static/media/LogoBlack.1563acdc.svg";